import { render } from "./UndefinedPhotoIcon.vue?vue&type=template&id=f8ba4848"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__